// ---------------------------------------------------------------------------
// Odoo Integration Types
// ---------------------------------------------------------------------------

/** Supported entity types for Odoo manual link operations. */
export enum OdooResourceType {
  ORGANIZATIONS = 'organizations',
  LEGAL_ENTITIES = 'legal-entities',
  CONTACTS = 'contacts',
  PLANS = 'plans',
}

// ---------------------------------------------------------------------------
// Odoo search result items
// ---------------------------------------------------------------------------

/** Single Odoo partner item from search results. */
export interface OdooPartnerItem {
  id: number;
  name: string;
  email?: string | false;
  is_company?: boolean;
  parent_id?: [number, string] | false;
  partner_group_id?: [number, string] | false;
  country_id?: [number, string] | false;
  street?: string | false;
  vat?: string | false;
  /** True when this Odoo record is already linked to a Hub resource. */
  isLinked?: boolean;
}

/** Single Odoo product item from search results. */
export interface OdooProductItem {
  id: number;
  name: string;
  default_code: string | false;
  list_price: number;
  standard_price: number;
  /** True when this Odoo record is already linked to a Hub resource. */
  isLinked?: boolean;
}

/** Union type for any Odoo search result item. */
export type OdooSearchItem = OdooPartnerItem | OdooProductItem;

// ---------------------------------------------------------------------------
// API response shapes
// ---------------------------------------------------------------------------

/** Response from link / unlink operations. */
export interface ManualLinkResult {
  success: boolean;
  hubId: string;
  odooId: number | null;
  message: string;
}

/** Response from push-to-odoo (create in Odoo) operations. */
export interface CreateInOdooResult {
  success: boolean;
  hubId: string;
  odooId: number;
  message: string;
}

/** Paginated response for unlinked Odoo resource searches. */
export interface UnlinkedOdooResource {
  total: number;
  items: OdooPartnerItem[] | OdooProductItem[];
}

// ---------------------------------------------------------------------------
// Helper: check if an item is a product (has default_code)
// ---------------------------------------------------------------------------

export function isOdooProductItem(item: OdooSearchItem): item is OdooProductItem {
  return 'default_code' in item;
}

export function isOdooPartnerItem(item: OdooSearchItem): item is OdooPartnerItem {
  return !('default_code' in item);
}
